import React, {useState} from 'react';
import {Icon, Modal, Grid} from 'semantic-ui-react';

const DocumentsTabTechDetailsModal = () => {
  const [showModal, setShowModal] = useState(false);

  const showModalClick = (e, value) => {
    e.preventDefault();
    setShowModal(value);
  };

  return (
    <Modal
      open={showModal}
      trigger={
        <Icon
          name='info circle'
          size="big"
          color="blue"
          link
          onClick={(e) => showModalClick(e, true)}
        />
      }
    >
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            Detalles técnicos: Documentos del Curso
          </h2>
          <Icon
            className='download'
            name='close'
            style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showModalClick(e, false)}
          />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid celled>
          <Grid.Row>
            <Grid.Column width={2}><strong>Frontend</strong></Grid.Column>
            <Grid.Column width={14}>
              /src/wts/components/courses/course/documentsTab.js
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>Backend (Documentos BD)</strong></Grid.Column>
            <Grid.Column width={14}>
              <div><strong>GET</strong>: /api/wts/course/doc?courseId=&#123;courseId&#125;</div>
              <div><strong>POST</strong>: /api/wts/course/doc</div>
              <div><strong>DELETE</strong>: /api/wts/course/doc?docId=&#123;docId&#125;</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>Backend (MongoDB)</strong></Grid.Column>
            <Grid.Column width={14}>
              <div><strong>POST</strong>: /api/answers (Guardar archivo base64)</div>
              <div><strong>GET</strong>: /api/answers/&#123;mongoId&#125; (Obtener archivo)</div>
              <div><strong>PUT</strong>: /api/answers/&#123;mongoId&#125; (Inactivar archivo)</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>Microservicios</strong></Grid.Column>
            <Grid.Column width={14}>
              <div><strong>part</strong>: Gestión de documentos en BD relacional</div>
              <div><strong>form</strong>: Gestión de archivos en MongoDB</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>BDD</strong></Grid.Column>
            <Grid.Column width={14}>
              <div>WTS.TDE_WTS_CURSO_DOCUMENTOS</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>Tipos de documento</strong></Grid.Column>
            <Grid.Column width={14}>
              <div><strong>STUDY_MATERIAL</strong>: Documentos de estudio</div>
              <div><strong>QUIZ</strong>: Cuestionarios</div>
              <div><strong>PRE_EVALUATION</strong>: Formularios pre evaluación</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>MongoDB collection</strong></Grid.Column>
            <Grid.Column width={14}>
              <div>type: WTS_DOC_STORAGE</div>
              <div>targetCollection: wtsDocStorage</div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

export default DocumentsTabTechDetailsModal;
